import * as React from 'react'
import { Row } from 'react-bootstrap'
import Location from '../../adLocations/Location'
import { Article, Variation } from '../articlesContainer'
import AddMorePanel from './AddMorePanel'
import VariationContainer from './VariationContainer'
import { AiVariationSuggestions } from './manageAiVariationsButton/aiVariationTypes'
import { AdFormats } from '../../adFormat/adFormat'

interface ArticlePanelProps {
	article: Article
	updateVariationField?: (
		uid: string,
		variationNum: number,
		prop: keyof Variation,
		value: any,
		instant?: boolean,
	) => void
	duplicateVariation?: (articleId: string, variationNo: number, instant?: boolean) => void
	removeVariation?: (articleId: string, variationNo: number, instant?: boolean) => void
	addVariation?: (articleId: string, instant?: boolean) => void
	selectedLocations?: Location[]
	campaignIsActive?: boolean
	instant?: boolean
	client?: {
		id: number
		org: string
	}
	campaignId?: number
	managingAiSuggestions?: boolean
	approveOrDisapproveAiSuggestion?: (variation: Variation, approve: boolean) => void
	adFormat: AdFormats
	readonly?: boolean
}

const ArticlePanel: React.SFC<ArticlePanelProps> = (props) => {
	const allSuggestions: AiVariationSuggestions = (props.article.variations || []).reduce(
		(suggestions: AiVariationSuggestions, variation: Variation) => ({
			title: [...suggestions.title, variation.title],
			summary: [...suggestions.summary, variation.description],
			call_to_action: [...suggestions.call_to_action, variation.cta],
		}),
		{
			title: [],
			summary: [],
			call_to_action: [],
		},
	)

	return (
		<Row>
			{props.article.variations.map((variation, index) => (
				<React.Fragment key={`${variation.uid}_${index}`}>
					<VariationContainer
						articleUid={props.article.uid}
						articleId={props.article.articleId}
						variation={variation}
						updateVariationField={props.updateVariationField}
						duplicateVariation={props.duplicateVariation}
						removeVariation={props.removeVariation}
						selectedLocations={props.selectedLocations}
						campaignIsActive={props.campaignIsActive}
						instant={props.instant}
						client={props.client}
						campaignId={props.campaignId}
						managingAiSuggestions={props.managingAiSuggestions}
						approveOrDisapproveAiSuggestion={props.approveOrDisapproveAiSuggestion}
						allSuggestions={allSuggestions}
						adFormat={props.adFormat}
						readonly={props.readonly}
					/>
					{index % 2 === 1 && <div className="clearfix visible-sm-block visible-md-block" />}
					{(props.managingAiSuggestions ? index % 4 === 3 : index % 3 === 2) && (
						<div className="clearfix visible-lg-block" />
					)}
				</React.Fragment>
			))}
			{!props.managingAiSuggestions && !props.readonly && (
				<AddMorePanel article={props.article} addVariation={props.addVariation} />
			)}
		</Row>
	)
}

export default ArticlePanel
